import $ from 'jquery'
import { getRecommendedDownloadLinkByUserAgent } from '../common'

$(init)

async function init () {
  let $downloadpage = $('#download-page')
  if ($downloadpage.length == 0) {
    return
  }
  let rkapp_dist_info
  { // load rkapp_dist_info
    let tmp = $('#rkapp-dist-info-json').html()
    if (tmp) {
      rkapp_dist_info = JSON.parse(tmp)
    }
  }
  if (!rkapp_dist_info) {
    return
  }
    
  let $recommended_download_sect = $downloadpage.find('.latest-recommended-download-section')
  if ($recommended_download_sect.length > 0) {
    let exec_file = getRecommendedDownloadLinkByUserAgent(rkapp_dist_info.latest.exec_list)
    if (exec_file) {
      let arch = rkapp_dist_info.arch_list.find((a) => a.name == exec_file.arch)
      let platform = rkapp_dist_info.platform_list.find((a) => a.name == exec_file.platform)
      if (arch && platform) {
        $recommended_download_sect.find('.download-link').attr('href', (new URL(exec_file.href, rkapp_dist_info.latest.base_url)).href)
        $recommended_download_sect.find('.arch').text(arch.label)
        $recommended_download_sect.find('.platform .text').text(platform.label)
        $recommended_download_sect.find('.platform .icon').addClass(platform.faicon)
        $recommended_download_sect.find('.filename').text(exec_file.filename)
        $recommended_download_sect.removeClass('d-none')
      }
    }
  }
}
